/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PermissionDTO
 */
export interface PermissionDTO {
    /**
     * 
     * @type {string}
     * @memberof PermissionDTO
     */
    permissionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionDTO
     */
    description?: string | null;
}

/**
 * Check if a given object implements the PermissionDTO interface.
 */
export function instanceOfPermissionDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PermissionDTOFromJSON(json: any): PermissionDTO {
    return PermissionDTOFromJSONTyped(json, false);
}

export function PermissionDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'permissionId': !exists(json, 'permissionId') ? undefined : json['permissionId'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function PermissionDTOToJSON(value?: PermissionDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'permissionId': value.permissionId,
        'description': value.description,
    };
}

